import React from 'react';
import { Button } from 'antd';
import { CameraOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { playerName } from '../../shared/utils/league-feed';

type Props = {
  event: LeagueFeed.Event;
  viewerId: string;
  // eslint-disable-next-line no-unused-vars -- callback type signature
  onOpen: (event: LeagueFeed.Event) => void;
};

/**
 * B4 (akış araştırması §13): izleyicinin son 2 günde akışa düşen fotoğrafsız maçı için tek satır
 * hatırlatma; karta götürür ("Maçını anlat" orada). Fotoğraflı maç yaklaşık iki kat tebrik alıyor.
 * T7 kuralında en düşük öncelikli görev: başka görev modülü yoksa görünür.
 */
export default function FeedStoryReminder({ event, viewerId, onOpen }: Props) {
  const { t } = useTranslation('leagues');
  const { veri } = event;
  const opponent = veri.kazanan?.id === viewerId ? veri.kaybeden : veri.kazanan;
  return (
    <section className="feed-catchup feed-story-reminder" aria-labelledby="feed-story-reminder">
      <p id="feed-story-reminder" className="feed-story-reminder__text">
        <CameraOutlined aria-hidden="true" />{' '}
        {t('detail.feed.storyReminder', { name: playerName(opponent) })}
      </p>
      <Button className="feed-catchup__clap" onClick={() => onOpen(event)}>
        {t('detail.feed.storyReminderOpen')}
      </Button>
    </section>
  );
}
